import React, { Component } from 'react';
import {
  Navbar,
  Nav,
  NavDropdown,
  Container,
} from 'react-bootstrap';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom'
import Sections from './sections';
import AppAlert from './common/AppAlert';
import './App.css';
import LogoImage from './assets/logo.png';

const { 
  Summary,
  Career,
  DesignAndArchitecture,
  Coding,
  Testing,
  OtherExperiences,
  Contributions,
  Contact,
} = Sections;

const withTransition = (comp) => (
  <div className="transition-wrapper">
    {comp}
  </div>
);

const Demo = () => (
  <div className="app">
    <Navbar collapseOnSelect expand="lg" bg="light" variant="light" fixed="top">
      <Container>
        <Navbar.Brand as={NavLink} to='/' style={{color:"#D4AF37"}}>
          <img
            width={18}
            height={18}
            className="mb-1"
            src={LogoImage}
            alt="CH"
          /> HANDRASHEKAR.CH</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-header-navbar-nav" />
        <Navbar.Collapse id="responsive-header-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link as={NavLink} to='/summary'>Summary</Nav.Link>
            <Nav.Link as={NavLink} to='/career'>Career</Nav.Link>
            <NavDropdown title='Experience' id='collasible-nav-dropdown'>
              <NavDropdown.Item as={NavLink} to='/designandarchitecture'>Design/Architecture</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to='/coding'>Coding</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to='/testing'>Testing</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={NavLink} to='/others'>Others</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={NavLink} to='/contributions'>Contributions</Nav.Link>
            <Nav.Link as={NavLink} to='/contact'>Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    <AppAlert />
    <Routes>
      <Route path="/" element={<Navigate to="/summary" replace />} />
      <Route path='/summary' element={withTransition(<Summary />)} />
      <Route path='/career' element={withTransition(<Career />)} />
      <Route path='/designandarchitecture' element={withTransition(<DesignAndArchitecture />)} />
      <Route path='/coding' element={withTransition(<Coding />)} />
      <Route path='/testing' element={withTransition(<Testing />)} />
      <Route path='/others' element={withTransition(<OtherExperiences />)} />
      <Route path='/contributions' element={withTransition(<Contributions />)} />
      <Route path='/contact' element={withTransition(<Contact />)} />
      <Route path='*' element={withTransition(<Summary />)} />
    </Routes>
     <Navbar collapseOnSelect expand="xl" bg="light" variant="light" fixed="bottom" className="footerbackgrund">
      <Container>
        <Navbar.Brand as={NavLink} to='/summary'>
          <img
            src={LogoImage}
            width={32}
            height={32}
            alt="CH"
          /> 
        </Navbar.Brand>
        <p style={{ color: 'lightgray', fontSize: '12px', fontWeight: 'bold', width: '200px'}}>
          <br/>
          Everything on this web page is handcoded and is solely designed and created by me.
          All rights reserverd.
        </p>
        <Navbar.Toggle aria-controls="responsive-footer-navbar-nav" />
        <Navbar.Collapse id="responsive-footer-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link as={NavLink} to='/summary'>Home</Nav.Link>
            <Nav.Link as={NavLink} to='/contact'>Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </div>
);

class App extends Component {
  render() {
    return (<Demo />);
  }
}

export default App;
